import { Capacitor } from '@capacitor/core';

/**
 * Platform detection utilities for ValuePlus app.
 * Determines whether running as native app or web browser.
 */

export const isNative = () => Capacitor.isNativePlatform();
export const isAndroid = () => Capacitor.getPlatform() === 'android';
export const isIOS = () => Capacitor.getPlatform() === 'ios';
export const isWeb = () => Capacitor.getPlatform() === 'web';
export const getPlatform = () => Capacitor.getPlatform();

/**
 * Check if a specific plugin is available on current platform
 */
export const isPluginAvailable = (pluginName) => {
  return Capacitor.isPluginAvailable(pluginName);
};

/**
 * Safe area insets for notch/island devices
 */
export const getSafeAreaStyle = () => {
  if (isNative()) {
    return {
      paddingTop: 'env(safe-area-inset-top)',
      paddingBottom: 'env(safe-area-inset-bottom)',
      paddingLeft: 'env(safe-area-inset-left)',
      paddingRight: 'env(safe-area-inset-right)',
    };
  }
  return {};
};
